import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useTranslation } from 'next-i18next';
import { RatingSummary } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingSummary/index.js';
import { RatingSummaryLoadingState } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/RatingSummary/components/LoadingState.js';
import { Badge } from '../../../../../../components/HotelDetailsOverlay/components/AmadeusRatingSection/components/Summary/components/Badge.js';
import { useAmadeusRating } from '../../../../../../components/HotelDetailsOverlay/hooks/useAmadeusRating.js';
import { HeadlineLarge, HelpTooltip, Flex } from '../../../../../../primitives/index.js';
import { HOTEL_DETAILS_QA_ID, qaId } from '../../../../../../utils/qaId.js';
export const Summary = ({
  loading,
  rating,
  recommendation,
  reviewsCount
}) => {
  const {
    t
  } = useTranslation();
  const formatScore = useAmadeusRating();
  const {
    scoreFormatted,
    scoreMax,
    sentiment,
    scoreDescription
  } = formatScore(rating);
  return _jsxs(Flex, {
    spacing: "pages/small",
    children: [_jsx("div", {
      children: _jsxs(Flex, {
        direction: "row",
        spacing: "8px",
        alignItems: "center",
        children: [_jsx(HeadlineLarge, {
          "data-testid": qaId(HOTEL_DETAILS_QA_ID, 'amadeusratingsection-headline'),
          children: t('hotelDetailsOverlay:amadeusRatingSection.summary.title')
        }), _jsx(HelpTooltip, {
          placement: "bottom",
          content: t('hotelDetailsOverlay:amadeusRatingSection.summary.tooltip')
        })]
      })
    }), loading ? _jsx(RatingSummaryLoadingState, {}) : _jsx(RatingSummary, {
      badge: _jsx(Badge, {
        score: scoreFormatted,
        scoreMax: scoreMax,
        sentiment: sentiment
      }),
      title: t('hotelDetailsOverlay:amadeusRatingSection.summary.overallRating', {
        description: scoreDescription
      }),
      subtitle: t('hotelDetailsOverlay:amadeusRatingSection.xReviews', {
        count: reviewsCount
      }),
      recommendation: recommendation == null ? undefined : t('hotelDetailsOverlay:amadeusRatingSection.summary.recommendation', {
        amount: recommendation % 1 > 0 ? recommendation.toFixed(1) : recommendation
      })
    })]
  });
};